import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export function useSubgoal() {
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/subgoal')
      .then((resp) => {
        if (cancelled) return;
        const list = Array.isArray(resp.data?.goals) ? resp.data.goals : [];
        setGoals(list);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setGoals([]);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  const refresh = useCallback(() => {
    setReloadKey((k) => k + 1);
  }, []);

  return { goals, loading, refresh };
}
